
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/ia/turnos-cargue-descargue",
      function () {
        return require("private-next-pages/es-co/ia/turnos-cargue-descargue/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/ia/turnos-cargue-descargue"])
      });
    }
  